<template lang="">
  <div :id="mapId"></div>
</template>
<script>
import mapboxgl from "mapbox-gl";
import "mapbox-gl/dist/mapbox-gl.css";
// import MethodService from "../service/MethodService";
export default {
  props: {
    propId: String,
    positionVulue: Array,
  },
  data() {
    return {
      mapId: this.propId ? this.propId : "map_" + parseInt(Math.random() * 1e6),
    };
  },
  methods: {
    fn_init() {
      // load tọa độ cho bản đồ
      mapboxgl.accessToken = "pk.eyJ1IjoidnVjb2RpaW5nIiwiYSI6ImNrdzBmcG8yeTFianUydnBhZHpmcXEzbzkifQ.RD1KCg_JbWOMCB_CL8pS4g";
      this.map = new mapboxgl.Map({
        container: this.mapId, // id từng bản đồ
        style: "mapbox://styles/mapbox/streets-v11", // kiểu bản đồ
        center: this.positionVulue,
        zoom: 15, // mức độ zoom
      });
      new mapboxgl.Marker({ color: "#9e1c1e" }).setLngLat(this.positionVulue).addTo(this.map);
      console.log("Tọa độ:", JSON.stringify(this.positionVulue));

      // tìm kiếm
      this.map.addControl(
        new MapboxGeocoder({
          accessToken: mapboxgl.accessToken,
          mapboxgl: mapboxgl,
        })
      );

      // phóng to, thu nhỏ
      this.map.addControl(new mapboxgl.NavigationControl());
    },
  },
  watch: {
    positionVulue(oldValue, newValue) {
      this.fn_init();
    },
  },
  mounted() {
    this.fn_init();
  },
};
</script>
<style lang=""></style>
